import { render, staticRenderFns } from "./StandServiceForm.vue?vue&type=template&id=4821333f&"
import script from "./StandServiceForm.vue?vue&type=script&lang=js&"
export * from "./StandServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports